import { CheckboxFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";

const blockFullWidthField = {
    displayName: "Full screen width",
    editorTemplate: "CheckboxField",
    defaultValue: false,
    fieldType: "General",
} as CheckboxFieldDefinition;

export default blockFullWidthField;
